import React from 'react';
import Block from '../../design-system/chat-blocks/Block';
import DailyBars from './charts/DailyBars';
import DailyLine from './charts/DailyLine';
import { fmtCompact, fmtUsd } from './format';

const RUN_SERIES = [
  { key: 'analyses', label: 'Web analyses', color: 'var(--chart-1)' },
  { key: 'auto_run', label: 'Agent AutoRuns', color: 'var(--chart-2)' },
  { key: 'train', label: 'API fits', color: 'var(--chart-4)' },
  { key: 'predict', label: 'API predictions', color: 'var(--chart-3)' },
  { key: 'forecast', label: 'API forecasts', color: 'var(--chart-5)' },
  { key: 'preprocess', label: 'API preprocessing', color: 'var(--chart-2)' },
  { key: 'pipeline_runs', label: 'Pipeline runs', color: 'var(--chart-3)' },
];

const pick = (series, key) => (key === 'analyses' || key === 'pipeline_runs' ? series[key] : series.sdk[key]);

const ActivityCharts = ({ series }) => {
  const runSeries = RUN_SERIES
    .map((s) => ({ ...s, values: pick(series, s.key) || [] }))
    .filter((s) => s.values.some((v) => v > 0) || ['analyses', 'train', 'predict'].includes(s.key));
  return (
    <div className="qa-two-col">
      <Block icon="bar-chart-3" title="Runs per day">
        <DailyBars
          days={series.days}
          series={runSeries}
          overlay={{ label: 'Failures', color: 'var(--danger)', values: series.failures }}
        />
      </Block>
      <Block icon="coins" title="LLM and GPU usage per day">
        <DailyLine
          days={series.days}
          series={[
            { key: 'tokens', label: 'Output tokens', color: 'var(--chart-1)', values: series.output_tokens, format: fmtCompact },
            { key: 'cost', label: 'LLM cost (by analysis start day)', color: 'var(--chart-2)', values: series.cost_usd, format: fmtUsd },
            { key: 'gpu', label: 'GPU cost', color: 'var(--chart-4)', values: series.gpu_cost_usd, format: fmtUsd },
            { key: 'chat', label: 'Chat messages', color: 'var(--chart-3)', values: series.chat_messages, format: fmtCompact },
          ]}
        />
      </Block>
    </div>
  );
};

export default ActivityCharts;
